module.exports = __webpack_public_path__ + "media/images/icon-checkbox-30546377.svg";